import { addMinutes, format } from 'date-fns';

export function formatDateAndTime(date) {
    const dateAndTimeFormat = "dd-MM-yyyy HH:mm"
    if(!date) return null;
    return format(typeof date === 'string' ? new Date(date) : date, dateAndTimeFormat)
}

export function getTimeFromMins(mins) { 
    const timeFormat = "HH:mm";
    const date = new Date().setHours(0,0,0,0);
    const added = addMinutes(date, mins);
    return format(added, timeFormat);
}

export const dayMapper = {
    sunday: {
      displayName: 'Sunday',
      name: 'sunday',
      number: 0,
    },
    monday: {
      displayName: 'Monday',
      name: 'monday',
      number: 1,
    },
    tuesday: {
      displayName: 'Tuesday',
      name: 'tuesday',
      number: 2,
    },
    wednesday: {
      displayName: 'Wednesday',
      name: 'wednesday',
      number: 3,
    },
    thursday: {
      displayName: 'Thursday',
      name: 'thursday',
      number: 4,
    },
    friday: {
      displayName: 'Friday',
      name: 'friday',
      number: 5,
    },
    saturday: {
      displayName: 'Saturday',
      name: 'saturday',
      number: 6,
    },
  };
  